import styled from '@emotion/styled';
import { pxToRem } from '@lbcamden/lib-react';

export const CompletionActionNoticeRoot = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: center;
  justify-content: space-between;
  max-width: ${pxToRem(570)};
  padding: ${({ theme }) => theme.spacing(3)};
  white-space: pre-wrap;
  background-color: ${({ theme }) => theme.colors.secondary};
  border-radius: ${pxToRem(3)};
`;
